// extracted by mini-css-extract-plugin
module.exports = {"pagination":"SearchPagination-module__pagination___4RZDO"};